// extracted by mini-css-extract-plugin
export default {"container":"DK-z","topReviewHeading":"EK-z","criticalReview":"FK-z","favorableReview":"GK-z","vsSeparator":"HK-z"};